import { SelectItemTypes } from "../../CommonTypes"
import { AreaRow } from "../areaTable/AreaTableType"

const API_BASE = process.env.REACT_APP_API_URL ?? ''

export const PrimaryCause: SelectItemTypes[] = [
    { name: "Southwest monsoon", value: "southwest_monsoon", isDisabled: false },
    { name: "Northeast monsoon", value: "northeast_monsoon", isDisabled: false },
    { name: "Low level atmospheric disturbance", value: "low_level_atmospheric_disturbance", isDisabled: false },
]

export const LightningRiskLevel: SelectItemTypes[] = [
    { name: "Low", value: "low", isDisabled: false },
    { name: "Moderate", value: "moderate", isDisabled: false },
    { name: "High", value: "high", isDisabled: false },
]

export const sideFieldCount = (totalField: number): number => {
    if (totalField > 0) {
        const value = totalField % 2

        if (value === 0){
            return totalField / 2
        } else {
            return (totalField + 1) /2
        }
    } else {
        return totalField
    }
}